var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeleteDropdownItemIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#071A24",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 9H11L11.7071 8.29289C11.8946 8.10536 12.149 8 12.4142 8H15.5858C15.851 8 16.1054 8.10536 16.2929 8.29289L17 9H19C19.5523 9 20 9.44772 20 10C20 10.5523 19.5523 11 19 11H9C8.44772 11 8 10.5523 8 10C8 9.44772 8.44772 9 9 9ZM19 12H9L9.80232 19.2209C9.91486 20.2337 10.771 21 11.7901 21H16.2099C17.229 21 18.0851 20.2337 18.1977 19.2209L19 12Z",
    fill: "#071A24",
    fillOpacity: 0.25
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeleteDropdownItemIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/delete_dropdown_item_icon.1d5973fca0ba8bc401ef29fe0d1dff8e.svg";